import React from 'react';
import { Dialog, DialogContent, Box } from '@mui/material';
import useIsMobile from '../hooks/useIsMobile';
import { HEADER_HEIGHT } from '../constants/layout';
import SalesOutreach from './SalesOutreach';

const SalesOutreachShell = ({
  open,
  onClose,
  recordId,
  companyName,
  contactInfo,
  openWithUrlSearch = false,
  onOutreachUpdate,
}) => {
  const isMobile = useIsMobile();

  if (!open) return null;

  if (isMobile) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: HEADER_HEIGHT,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: (theme) => theme.zIndex.modal,
          bgcolor: 'background.default',
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <SalesOutreach
          recordId={recordId}
          companyName={companyName}
          contactInfo={contactInfo}
          onClose={onClose}
          onOutreachUpdate={onOutreachUpdate}
          openWithUrlSearch={openWithUrlSearch}
        />
      </Box>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogContent sx={{ p: 0, flexGrow: 1, overflow: 'auto' }}>
        <SalesOutreach
          recordId={recordId}
          companyName={companyName}
          contactInfo={contactInfo}
          onClose={onClose}
          onOutreachUpdate={onOutreachUpdate}
          openWithUrlSearch={openWithUrlSearch}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SalesOutreachShell;
